import { DataWithPagination } from '@/shared/types';
import { Key, ReactNode, useContext } from 'react';
import { FilterSearchBar, TablePaginationContext } from '..';
import { Pagination } from '../TablePaginationContextProvider/Pagination';
import { SortableColumnDef, SortableTable } from '../TableV2/SortableTable';

type PagedTable<T> = {
  title: string;
  page?: DataWithPagination<T[]>;
  columns: SortableColumnDef<T>[];
  isLoading: boolean;
  emptyStateMessage: string;
  actions?: ReactNode;
};

export const PagedTable = <T extends { id: Key }>({
  title,
  page,
  columns,
  isLoading,
  emptyStateMessage,
  actions,
}: PagedTable<T>) => {
  const {
    page: pageNumber,
    handleSearchChange,
    onSort,
    onPageChange,
  } = useContext(TablePaginationContext);

  return (
    <>
      <div className="center flex flex-row">
        <FilterSearchBar
          total={page?.totalRows || 0}
          title={title}
          onSearch={handleSearchChange}
          variant={'secondary'}
          otherActions={actions}
        />
      </div>
      <SortableTable<T>
        columns={columns}
        rows={page?.items ?? []}
        emptyStateMessage={emptyStateMessage}
        isLoading={isLoading}
        loadingRows={3}
        onSort={(sorts) =>
          onSort(
            sorts.map((sort) => ({
              columnId: sort.accessor.toString(),
              direction: sort.direction,
            })),
          )
        }
      />
      {!!page?.totalPages && (
        <Pagination
          currentPage={pageNumber}
          onPageChange={onPageChange}
          totalPages={page.totalPages}
        />
      )}
    </>
  );
};
